import React, { Component } from "react";
import { updateNode } from "../Helpers/Nodes";

class Theme extends Component {
	constructor(props) {
		super(props);

		this.state = {
			user: { ...this.props.user },
		};

		if (!this.state.user.defaultTheme) this.updateUser("light");
	}

	render() {
		return (
			<div className="py-3 d-flex flex-column ms-2">
				<div className="px-1"><strong>Theme</strong></div>
				<div className="py-2 ps-1">
					<span
						className="rounded pointer p-2 pe-3 ps-3 dark-template"
						onClick={() => {
							this.updateUser("dark");
						}}
					>
						Dark
						{this.state.user.defaultTheme === "dark" && <i className="fas fa-check-circle mx-1"></i>}
					</span>
				</div>
				<div className="py-2 ps-1">
					<span
						className="rounded pointer p-2 pe-3 ps-3 light-template"
						onClick={() => {
							this.updateUser("light");
						}}
					>
						Light
						{(this.state.user.defaultTheme === "light" || this.state.user.defaultTheme === null) && <i className="fas fa-check-circle mx-1"></i>}
					</span>
				</div>
			</div>
		);
	}

	updateUser = async (theme) => {
		let { user } = this.state;

		// update database
		await updateNode("User", user.id, {
			defaultTheme: theme,
		});

		//  update local storage
		localStorage.setItem("theme", theme);

		// change the css global theme
		document.documentElement.className = "theme-" + theme;
		user.defaultTheme = theme;

		// set state
		this.setState(user);
	};
}

export default Theme;
